<template>
  <AsidePanel
    ref="asidePanel"
    :components="components"
    :disableCta="shouldDisableCta"
    :handleMountedCallback="handleMountedCallback"
    :handleSave="handleSave"
    :isExpanded="isExpanded"
    :itemId="itemId"
    :itemType="itemType"
    :navigateToTab="activeTab"
    :redirectTo="`/managedSoftware/apple`"
    :viewport="viewport"
  >
    <template
      v-slot:avatar
    >
      <img
        v-if="getAppleVppData"
        :class="$style.centered"
        :src="getAppleVppIcon"
      >
      <svg viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg" v-else="" :class="$style.centered" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M123.5 65.25c0 31.067-25.185 56.25-56.25 56.25S11 96.317 11 65.25C11 34.182 36.185 9 67.25 9s56.25 25.182 56.25 56.25z" fill="#F6F6F7"/><path fill-rule="evenodd" clip-rule="evenodd" d="M118 65.25C118 93.278 95.28 116 67.25 116 39.221 116 16.5 93.278 16.5 65.25S39.221 14.5 67.25 14.5C95.28 14.5 118 37.222 118 65.25z" fill="#E8E8E6"/><path fill-rule="evenodd" clip-rule="evenodd" d="M43.8 79.375a4.966 4.966 0 004.514 2.875h36.679a5.823 5.823 0 004.28-1.87l.927-1.005H43.8zm46.4-5.75a5.802 5.802 0 015.307 3.431 5.712 5.712 0 01-1.027 6.199l-.926 1.005A11.646 11.646 0 0184.993 88H48.314c-4.152 0-7.929-2.368-9.713-6.073A5.687 5.687 0 0138 79.375c0-3.176 2.597-5.75 5.8-5.75v-23c0-4.764 3.895-8.625 8.7-8.625h29c4.805 0 8.7 3.861 8.7 8.625v23zm-40.6 0h34.8v-23c0-1.588-1.299-2.875-2.9-2.875h-29c-1.602 0-2.9 1.287-2.9 2.875v23z" fill="#626B73"/><path fill-rule="evenodd" clip-rule="evenodd" d="M59.85 52h-3.6c-1.243 0-2.25.951-2.25 2.125v3.4c0 1.174 1.007 2.125 2.25 2.125h3.6c1.243 0 2.25-.951 2.25-2.125v-3.4c0-1.174-1.007-2.125-2.25-2.125zm0 9.35h-3.6c-1.243 0-2.25.951-2.25 2.125v3.4C54 68.049 55.007 69 56.25 69h3.6c1.243 0 2.25-.951 2.25-2.125v-3.4c0-1.174-1.007-2.125-2.25-2.125zm-4.05 2.125c0-.235.202-.425.45-.425h3.6c.248 0 .45.19.45.425v3.4a.438.438 0 01-.45.425h-3.6a.438.438 0 01-.45-.425v-3.4zm10.35-2.125h3.6c1.243 0 2.25.951 2.25 2.125v3.4C72 68.049 70.993 69 69.75 69h-3.6c-1.243 0-2.25-.951-2.25-2.125v-3.4c0-1.174 1.007-2.125 2.25-2.125zm3.6-9.35h-3.6c-1.243 0-2.25.951-2.25 2.125v3.4c0 1.174 1.007 2.125 2.25 2.125h3.6c1.243 0 2.25-.951 2.25-2.125v-3.4C72 52.951 70.993 52 69.75 52z" fill="#F9FAFB"/><path fill-rule="evenodd" clip-rule="evenodd" d="M59.85 52h-3.6c-1.243 0-2.25.951-2.25 2.125v3.4c0 1.174 1.007 2.125 2.25 2.125h3.6c1.243 0 2.25-.951 2.25-2.125v-3.4c0-1.174-1.007-2.125-2.25-2.125zm0 9.35h-3.6c-1.243 0-2.25.951-2.25 2.125v3.4C54 68.049 55.007 69 56.25 69h3.6c1.243 0 2.25-.951 2.25-2.125v-3.4c0-1.174-1.007-2.125-2.25-2.125zm-4.05 2.125c0-.235.202-.425.45-.425h3.6c.248 0 .45.19.45.425v3.4a.438.438 0 01-.45.425h-3.6a.438.438 0 01-.45-.425v-3.4zm10.35-2.125h3.6c1.243 0 2.25.951 2.25 2.125v3.4C72 68.049 70.993 69 69.75 69h-3.6c-1.243 0-2.25-.951-2.25-2.125v-3.4c0-1.174 1.007-2.125 2.25-2.125zm3.6-9.35h-3.6c-1.243 0-2.25.951-2.25 2.125v3.4c0 1.174 1.007 2.125 2.25 2.125h3.6c1.243 0 2.25-.951 2.25-2.125v-3.4C72 52.951 70.993 52 69.75 52z" fill="#626B73"/></svg>
    </template>
    <template v-slot:leftPaneCustomContent>
      <p :class="$style.appSeller">
        {{ getSeller }}
      </p>
    </template>
  </AsidePanel>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { get } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import AppleVppIconMixin from 'client/SoftwareApps/mixins/AppleVppIconMixin';
import AsidePanel from 'client/components/AsidePanel/AsidePanel.vue';
import AsidePanelPropsMixin from 'client/components/AsidePanel/mixins/AsidePanelPropsMixin';
import ItemType from 'client/util/Constants/ItemType';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import SaveReturnValue from 'client/components/AsidePanel/SaveReturnValue';
import SoftwareAppsStatusItemTable from 'client/SoftwareApps/SoftwareAppsStatusItemTable';
import SystemFilters from 'client/components/ItemTable/CollectionFilterComponents/constants/SystemFilters';
import SystemGroupItemTable from 'client/components/ItemTable/SystemGroupItemTable';
import SystemItemTable from 'client/systems/SystemItemTable/SystemItemTable.vue';
import VppSoftwareAppsDetails from 'client/SoftwareApps/VppSoftwareAppsDetails.vue';
import pluralize from 'pluralize';

const { warn } = Constants.default;
const {
  ItemActionConsts,
  ItemTableConsts,
  ItemTypeConsts,
  LogicalOperators,
  StoreModelMap,
  VppSupportedDeviceConst,
} = Constants;
const { parentOSType } = ItemTableConsts;
const { darwin } = parentOSType;
const { create, update } = ItemActionConsts;
const { tvOS } = Constants.default;
const { iPad, iPhone } = VppSupportedDeviceConst;
const { DeviceItemType, DeviceGroupItemType } = ItemType;
const deviceItem = new DeviceItemType();
const deviceGroupItem = new DeviceGroupItemType();
const softwareAppsModel = StoreModelMap[ItemTypeConsts.softwareApps];

export default {
  name: 'VppSoftwareAppsAsidePanel',

  components: {
    AsidePanel,
  },

  mixins: [
    AppleVppIconMixin,
    AsidePanelPropsMixin,
  ],

  props: {
    navigateToTab: {
      type: Object,
      default: () => {},
      validator(obj) {
        if (obj) {
          return typeof obj.tabLabel !== 'undefined';
        }
        return true;
      },
    },
  },

  data() {
    return {
      activeTab: this.navigateToTab,
      itemHasBeenSaved: false,
      errorMessage: 'Please review the Details Tab for missing or invalid information',
      supportingVpp: KbArticleUrls.supportingVpp,
      warn,
    };
  },

  computed: {
    ...mapState(softwareAppsModel, ['item']),

    ...mapGetters(softwareAppsModel, [
      'hasItemChanged',
      'haveAssociationsChanged',
      'isItemBeingCreated',
      'displayName',
      'getModifiedAssociations',
    ]),

    components() {
      const systemItemTableFilters = this.getSupportedDevicesFilters();

      const components = [
        {
          label: 'Details',
          vueComponent: VppSoftwareAppsDetails,
        },
        {
          itemType: ItemTypeConsts.systemGroup,
          label: `${deviceGroupItem.titlePlural}`,
          headerLabels: {
            [create]: `Deploy to the following ${deviceGroupItem.titlePlural}`,
            [update]: `is deployed to the following ${deviceGroupItem.titlePlural}`,
          },
          vueComponent: SystemGroupItemTable,
          vueComponentProps: {
            boundItemsUrl: this.itemId ? `/api/v2/softwareapps/${this.itemId}/systemgroups` : undefined,
            inDetailsAsidePanel: true,
            panelType: ItemTableConsts.panelType.softwareAppsAsidePanel,
          },
        },
        {
          itemType: ItemTypeConsts.system,
          label: `${deviceItem.title}`,
          headerLabels: {
            [create]: `Deploy to the following ${deviceItem.labelPlural}`,
            [update]: `is deployed on the following devices ${deviceItem.labelPlural}`,
          },
          vueComponent: SystemItemTable,
          vueComponentProps: {
            boundItemsUrl: this.itemId ? `/api/v2/softwareapps/${this.itemId}/systems` : undefined,
            inDetailsAsidePanel: true,
            panelType: ItemTableConsts.panelType.softwareAppsAsidePanel,
            collectionFilters: systemItemTableFilters,
          },
        },
        {
          label: 'Status',
          vueComponent: SoftwareAppsStatusItemTable,
          vueComponentProps: {
            softwareAppsId: this.itemId,
            isAppleVpp: true,
          },
        },
      ];
      return components;
    },

    getAppleVppData() {
      return this.item ? get(this.item, 'settings[0].appleVpp', {}) : {};
    },

    /**
     * This was necessary as the URL comes in the following format:
     * https://is3-ssl.mzstatic.com/image/thumb/Purple114/v4/d6/ae/06/d6ae0651-c69e-474f-b314-6119a8b38063/AppIcon-peach-85-220-4-2x.png/{w}x{h}bb.{f}
     *
     * w = width
     * h = height
     * f = format
     */
    getAppleVppIcon() {
      const uglyUrl = get(this.getAppleVppData, 'details.artwork.url', '');
      return this.configureIconUrl({ uglyUrl, width: '136', height: '136' });
    },

    getSeller() {
      return get(this.getAppleVppData, 'details.softwareInfo.seller', '');
    },

    shouldDisableCta() {
      return !(this.hasItemChanged || this.haveAssociationsChanged) || this.isItemBeingCreated;
    },

  },

  beforeMount() {
    this.updateData();
  },

  methods: {
    ...mapActions(softwareAppsModel, [
      'saveItem',
      'bindSoftwareAppToSystems',
      'bindSoftwareAppToSystemGroups',
    ]),

    confirmBindings() {
      const bindings = this.getModifiedAssociations;
      const mdTemplate = this.getBindingsModalBodyText(bindings);

      return new Promise((resolve) => {
        ModalEventBus.open({
          component: 'ConfirmationModal',
          componentProps: {
            mdTemplate,
            headerText: 'Managed Software Associations',
            continueText: 'save',
            handleContinue: () => {
              ModalEventBus.close();
              resolve(true);
            },
            handleCancel: () => {
              ModalEventBus.close();
              resolve(false);
            },
          },
        });
      });
    },

    getBindingsModalBodyText(bindings) {
      const {
        systemsToBind,
        systemGroupsToBind,
        systemsToUnbind,
        systemGroupsToUnbind,
      } = bindings;
      const deviceLabel = pluralize(`${deviceItem.label}`, systemsToUnbind.length);
      const deviceBindLabel = pluralize(`${deviceItem.label}`, systemsToBind.length);
      const deviceBindGroupsLabel = pluralize(`${deviceGroupItem.label}`, systemGroupsToBind.length);
      const deviceGroupsLabel = pluralize(`${deviceGroupItem.label}`, systemGroupsToUnbind.length);
      let boundText = '';
      let unboundText = '';
      let uninstallText = '';

      if (systemsToBind.length && systemGroupsToBind.length) {
        boundText = `The managed software **${this.displayName}** will be installed on **${systemsToBind.length} ${deviceBindLabel}** directly and to **devices** in **${systemGroupsToBind.length} ${deviceBindGroupsLabel}**.`;
      } else {
        boundText = systemsToBind.length ? `The managed software **${this.displayName}** will be installed on **${systemsToBind.length} ${deviceBindLabel}**.` : boundText;
        boundText = systemGroupsToBind.length ? `The managed software **${this.displayName}** will be installed on **devices** in **${systemGroupsToBind.length} ${deviceBindGroupsLabel}**.` : boundText;
      }
      boundText = boundText ? `${boundText}\n\nAfter installation, the software will be managed by JumpCloud.\n\n*Tip: Perform a test installation of managed software before you bind the software to your entire fleet.*\n\n` : boundText;

      if (systemsToUnbind.length && systemGroupsToUnbind.length) {
        unboundText = `The managed software **${this.displayName}** will no longer be managed on **${systemsToUnbind.length} ${deviceLabel}** directly and on **devices** in **${systemGroupsToUnbind.length} ${deviceGroupsLabel}**.`;
        uninstallText = `Licenses for **${this.displayName}** app will be reclaimed for **${systemsToUnbind.length} ${deviceLabel}** and **${systemGroupsToUnbind.length} ${deviceGroupsLabel}**.`;
      } else {
        unboundText = systemsToUnbind.length ? `The managed software **${this.displayName}** will no longer be managed on **${systemsToUnbind.length} ${deviceLabel}** directly.` : unboundText;
        unboundText = systemGroupsToUnbind.length ? `The managed software **${this.displayName}** will no longer be managed on **devices** in **${systemGroupsToUnbind.length} ${deviceGroupsLabel}**.` : unboundText;
        uninstallText = systemGroupsToUnbind.length ? `Licenses for **${this.displayName}** app will be reclaimed from **devices** in **${systemGroupsToUnbind.length} ${deviceGroupsLabel}**.` : uninstallText;
        uninstallText = systemsToUnbind.length ? `Licenses for **${this.displayName}** app will be reclaimed for **${systemsToUnbind.length} ${deviceLabel}** .` : uninstallText;
      }

      unboundText = unboundText ? `${unboundText}\n\n${uninstallText}` : unboundText;

      return `${boundText}${unboundText}`;
    },

    getSupportedDevicesFilters() {
      const supportedDevices = get(this.getAppleVppData, 'supportedDeviceFamilies', []);
      const filterMap = {
        IPADONLY: [
          SystemFilters.mdmEnrollmentType('device', LogicalOperators.or, true),
          SystemFilters.mdmEnrollmentType('automated device', LogicalOperators.or, true),
          SystemFilters.os({
            os: 'iPadOS', operator: 'eq', logicalOperator: LogicalOperators.and, duplicate: true,
          }),
        ],
        IPAD: [],
        IPHONE: [
          SystemFilters.mdmEnrollmentType('device', LogicalOperators.or, true),
          SystemFilters.mdmEnrollmentType('automated device', LogicalOperators.or, true),
        ],
        IPOD: [],
        MAC: [
          SystemFilters.osFamily(darwin, LogicalOperators.or),
          SystemFilters.mdm('internal', LogicalOperators.and),
        ],
        MACONLY: [
          SystemFilters.osFamily(darwin, LogicalOperators.and),
          SystemFilters.mdm('internal', LogicalOperators.and),
        ],
      };

      let systemItemTableFilters = [SystemFilters.os({
        os: tvOS, operator: '$ne', logicalOperator: LogicalOperators.and, duplicate: true,
      })];

      supportedDevices.forEach((supportedDevice) => {
        if (supportedDevices.length === 1 && supportedDevice !== iPhone) {
          systemItemTableFilters = systemItemTableFilters.concat(filterMap[`${supportedDevice}ONLY`]);
        } else {
          systemItemTableFilters = systemItemTableFilters.concat(filterMap[supportedDevice]);
        }
      });

      if (this.$hasFeatureFlag(this.$featureFlags.byodVpp)) {
        if (supportedDevices.indexOf(iPad) > -1 || supportedDevices.indexOf(iPhone) > -1) {
          systemItemTableFilters.push(SystemFilters.mdmEnrollmentType('user', LogicalOperators.or, true));
        }
      }

      return systemItemTableFilters;
    },

    handleMountedCallback() {
      if (this.navigateToTab) {
        this.navigateToAsideTab(this.navigateToTab.tabLabel);
      }
    },

    async handleSave() {
      await this.$validator.validate();

      if (this.$validator.errors.any()) {
        throw Error(this.errorMessage);
      }

      this.itemHasBeenSaved = true;

      if (this.haveAssociationsChanged) {
        const canContinue = await this.confirmBindings();

        if (canContinue === false) {
          return new SaveReturnValue({ canContinue, noNotification: true });
        }
      }
      try {
        await this.bindSoftwareAppToSystemGroups();
        await this.bindSoftwareAppToSystems();
        if (this.hasItemChanged) {
          await this.saveItem();
        }
        return true;
      } catch (error) {
        throw error instanceof Error ? error : Error('Unknown error');
      }
    },

    hasModelChanged() {
      if (this.itemHasBeenSaved) {
        return false;
      }
      return this.hasItemChanged || this.haveAssociationsChanged;
    },

    navigateToAsideTab(tabLabel) {
      this.activeTab = { tabLabel };
    },

    updateData() {
      const deviceGroupsComponent = this.components[1];
      const devicesComponent = this.components[2];
      const {
        label, labelPlural, titlePlural, type,
      } = deviceItem;

      deviceGroupsComponent.itemType = deviceGroupItem.type;
      deviceGroupsComponent.label = deviceGroupItem.titlePlural;
      deviceGroupsComponent.headerLabels = {
        [create]: `Deploy to the following ${label} groups. Software is only installed on macOS ${labelPlural}`,
        [update]: ` is deployed to the following ${label} groups. Software is only installed on macOS ${labelPlural}`,
      };

      devicesComponent.itemType = type;
      devicesComponent.label = titlePlural;
      devicesComponent.headerLabels = {
        [create]: `Deploy to the following ${labelPlural}`,
        [update]: `is deployed on the following ${labelPlural}`,
      };
    },
  },
};
</script>

<style module>
.appSeller {
  text-align: center;
}

.centered {
  display: block;
  margin: 0 auto;
}
</style>
